import { render, staticRenderFns } from "./dialog-person-offline.vue?vue&type=template&id=61ae1536&"
import script from "./dialog-person-offline.vue?vue&type=script&lang=js&"
export * from "./dialog-person-offline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports